const steps = [
  {
    img: "img2/1-Data-Collection.png.webp",
    title: "Student & Staff Data Collection",
    desc: "Collect essential details such as name, class, section, Father Name, Mobile number, and address through a secure system or in excel sheet."
  },
  {
    img: "img2/2-Photo-capture-app.png.webp",
    title: "Photo Capture via App",
    desc: "Photos are captured using a mobile or web app ensuring clarity and uniform image, it takes only 15 mins for entire school."
  },
  {
    img: "img2/3-Lanyard-ID-Card-Design.png.webp",
    title: "Automatic ID Card Design",
    desc: "Professionally designed ID cards and lanyards with school branding and QR/barcode integration."
  },
  {
    img: "img2/4-Easy-ID-card-correction.png.webp",
    title: "Automatic ID Card Generation",
    desc: "Teachers can preview and generate ID cards instantly with easy corrections."
  },
  {
    img: "img2/5-QuickID-Cards-Generator.png.webp",
    title: "Printing & Quality Check",
    desc: "High-quality printing with strict quality checks."
  },
  {
    img: "img2/6-Print-Delivery.png.webp",
    title: "Doorstep Delivery",
    desc: "Final ID cards are securely packed and delivered on time."
  }
];

export default function WorkSection() {
  return (
    <section className="work-section">
      <div className="work-container">

        <h2>
          How It <span>Works</span>
        </h2>

        <p className="work-subtitle">
          Our simple and efficient process ensures quick and accurate ID card generation.
        </p>

        <div className="work-steps">
          {steps.map((step, i) => (
            <div key={i} className="step-box">

              <img
                src={step.img}
                className="img-fluid"
                style={{ borderRadius: "10px" }}
                alt={step.title}
              />

              <h3>{step.title}</h3>

              <p>{step.desc}</p>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
